/**
 * Which shell the page runs in: the web app, or a native one around the same files. It is fixed when the
 * app is built (`vite build --mode capacitor`), and written as a constant, so that what belongs to a shell
 * is not in the files of the others (the web build has no trace of the Capacitor plugins).
 */
export const IN_CAPACITOR: boolean = import.meta.env.VITE_SHELL === 'capacitor';
export const IN_TAURI: boolean = import.meta.env.VITE_SHELL === 'tauri';
/** Either: the app is a program of the device, not a page, so a provider's page opens in the system browser. */
export const IN_NATIVE: boolean = IN_CAPACITOR || IN_TAURI;

/** The address a provider or an e-mail link sends the player back to in the native apps. */
export const NATIVE_AUTH_REDIRECT = 'ilcolpo://auth/callback';

/**
 * The link that brings somebody to a private room. On the web it is this page's own address; in a native app
 * the page's address (`https://localhost`, `http://tauri.localhost`) means nothing to anybody else, so it is the public address of the web
 * app (`VITE_PUBLIC_URL`), and with none the app's own link (`ilcolpo://join/CODE`, which only works for
 * somebody who already has the app).
 */
export function inviteLink(
  code: string,
  publicUrl: string | undefined = import.meta.env.VITE_PUBLIC_URL,
  origin: string = location.origin,
  native: boolean = IN_NATIVE,
): string {
  const base = publicUrl?.trim().replace(/\/+$/, '');
  if (base) return `${base}/online/join/${code}`;
  return native ? `ilcolpo://join/${code}` : `${origin}/online/join/${code}`;
}
